import{gql as e}from"graphql-tag";import{MessageFragmentDoc as o,MessageResourceFragmentDoc as s,MessageMeditationResourceFragmentDoc as t,MessageProgramResourceFragmentDoc as n}from"./fragments.generated.es.js";const g=e`
    mutation NewMessage($conversationUuid: UUID!, $content: String!) {
  newMessage(conversationUuid: $conversationUuid, content: $content) {
    ok
    message {
      ...message
    }
  }
}
    ${o}
${s}
${t}
${n}`;export{g as NewMessageDocument};
//# sourceMappingURL=newMessageMutation.generated.es.js.map
